// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"4788bc8b68fa9bfb","5763":"f269da8dd18b2b65","7222":"2c652bd6a227969c","7937":"8a0423e7e3fc5332"}[chunkId] + ".js";
};